import { PushbuttonHref } from '@stratumn/atomic';

import axaLogo from 'assets/axa_logo_white.svg';
import conduentLogo from 'assets/conduent.svg';
import siaPartnersLogo from 'assets/sia_partners_logo.png';
import { MICROSOFT_SIA_URL, ONE_ACCOUNT_AXA_URL } from 'constant/api';
import { ROUTE_LOGIN } from 'constant/routes';
import {
  AUTH_PROVIDER_CONDUENT,
  AUTH_PROVIDER_MICROSOFT_SIA,
  AUTH_PROVIDER_ONE_ACCOUNT_AXA
} from 'constant/types';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import qs from 'query-string';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router-dom';
import styles from './oauthOptions.style';

export const OauthOptions = props => {
  const { classes, location, providers } = props;

  const oauthUrl = providerUrl => {
    const {
      responseType,
      clientId,
      redirectUri,
      codeChallenge,
      codeChallengeMethod,
      invitationToken
    } = qs.parse(location.search);

    const provider =
      {
        [ONE_ACCOUNT_AXA_URL]: AUTH_PROVIDER_ONE_ACCOUNT_AXA,
        [MICROSOFT_SIA_URL]: AUTH_PROVIDER_MICROSOFT_SIA
      }[providerUrl] || '';

    const state = Buffer.from(
      JSON.stringify({
        redirectUri,
        responseType,
        clientId,
        codeChallenge,
        codeChallengeMethod,
        provider,
        invitationToken
      })
    ).toString('base64');
    return `${providerUrl}&state=${state}`;
  };

  const containsProvider = p => !providers || providers.includes(p);

  const oneAccount = containsProvider(AUTH_PROVIDER_ONE_ACCOUNT_AXA) && (
    <PushbuttonHref
      href={oauthUrl(ONE_ACCOUNT_AXA_URL)}
      prefix={<img alt="Axa logo" className={classes.axaLogo} src={axaLogo} />}
      primary
    >
      One Account AXA
    </PushbuttonHref>
  );

  const microsoftSia = containsProvider(AUTH_PROVIDER_MICROSOFT_SIA) && (
    <PushbuttonHref
      href={oauthUrl(MICROSOFT_SIA_URL)}
      prefix={
        <img
          alt="sia partners logo"
          className={classes.siaPartnersLogo}
          src={siaPartnersLogo}
        />
      }
      primary
    >
      Sia Partners
    </PushbuttonHref>
  );

  const conduent = containsProvider(AUTH_PROVIDER_CONDUENT) && (
    <PushbuttonHref
      href={`${ROUTE_LOGIN}?provider=conduent`}
      prefix={
        <img
          alt="Conduent logo"
          className={classes.conduentLogo}
          src={conduentLogo}
        />
      }
      primary
    >
      Conduent Login
    </PushbuttonHref>
  );

  return (
    <div className={classes.oauthOptions}>
      {oneAccount}
      {microsoftSia}
      {conduent}
    </div>
  );
};

OauthOptions.propTypes = {
  location: PropType.object.isRequired,
  classes: PropType.object.isRequired,
  providers: PropType.arrayOf(PropType.string)
};

OauthOptions.defaultProps = {
  providers: null
};

export default compose(withRouter, injectSheet(styles))(OauthOptions);
